import React from "react";
import { Box, Tooltip } from "@mui/material";
import {
  Error as ErrorIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";

const ExtractionQualityReviewFlag = ({ answer }) => {
  const qualityReview = answer.handwrittenAnswerFile?.extractionQualityReview;

  if (!qualityReview || !qualityReview.reviewSuggested) {
    return null;
  }

  const isLowQuality = qualityReview.qualityLevel === "low";
  const Icon = isLowQuality ? ErrorIcon : WarningIcon;
  const color = isLowQuality ? "error.main" : "warning.main";

  return (
    <Tooltip title={qualityReview.qualityReason} arrow>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Icon fontSize="small" sx={{ color }} />
      </Box>
    </Tooltip>
  );
};

export default ExtractionQualityReviewFlag;
